import { useEffect, useState } from 'react';
import { MEDICAL_HISTORY } from 'src/enums';

import { MedicalHistoryScreen } from '../medicalHistory';
interface Props {
  title?: string;
}

export default function Home() {
  // TOOLS

  const [activeKey, setActiveKey] = useState<MEDICAL_HISTORY>(
    MEDICAL_HISTORY.HOME
  );

  useEffect(() => {
    console.log('Active key changed to:', activeKey);
  }, [activeKey]);

  return (
    <MedicalHistoryScreen setActive={setActiveKey} activeKey={activeKey} />
  );
}
